import { selectBookingAsyncResponse } from "./types";
import * as bookingActions from "./actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_BOOKING, retrieveToken } from "../../../helpers/api";

export function* selectBooking(action: ReturnType<typeof bookingActions.selectBookingAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_BOOKING.SELECT_BOOKING(action.payload.id), token);
    if (result.status === 200) {
      const parsed: selectBookingAsyncResponse = yield call(result.json.bind(result));
      yield put(bookingActions.selectBookingAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bookingActions.selectBookingAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(bookingActions.selectBookingAsync.failure(parsed));
  }
}

export default function* bookingsSagaSelectBooking() {
  yield takeEvery(bookingActions.selectBookingAsync.request, selectBooking);
}
